import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Dropzone from 'react-dropzone';
import classNames from 'classnames';
import { config, postFiles } from './api';
import { get } from '../../redux/modules/images';
import { Icon } from 'react-fa';
import { IMAGES_REPO } from '../../config';

class ImageUploader extends React.Component {
  state = { files: [], selectedIndex: -1, selectedIndexs: [] };

  getData() {
    this.props.getAsync();
  }

  componentWillMount() {
    this.getData();
  }

  onDrop = (acceptedFiles, rejectedFiles) => {
    const getData = this.getData.bind(this);

    this.setState({
      isUploading: true
    });
    postFiles(acceptedFiles, () => {
      getData();
      this.setState({
        isUploading: false
      });
    });
  };

  onDragOver = () => {
    console.log('onDragOver');
    this.setState({ onDragOver: true });
  };

  onDragLeave = () => {
    console.log('onDragLeave');
    this.setState({ onDragOver: false });
  };

  render() {
    const { isMultipleSelect = false, cancel, select, images: { values, isFetching } } = this.props;
    const classNameLoading = classNames({
      'image-uploader__loading': true,
      'image-uploader__loading--true': this.state.isUploading || isFetching
    });
    return (
      <div className="image-uploader">
        <div className="image-uploader__container">
          <div className={classNameLoading}><Icon spin name="spinner"/></div>
          <Dropzone
            ref="dropzoneRef"
            disableClick={true}
            onDragOver={this.onDragOver}
            onDragLeave={this.onDragLeave}
            className="image-uploader__drop-zone"
            accept={config.acceptFormats}
            onDrop={this.onDrop.bind(this)}>
            {
              values.map((imageInfo, index) => {
                const selectedIndex = isMultipleSelect ? this.state.selectedIndexs : this.state.selectedIndex;
                const className = classNames({
                  'check-btn': true,
                  'check-btn--selected': isMultipleSelect ? selectedIndex.indexOf(index) > -1 : selectedIndex === index
                });
                return (
                  <div
                    onClick={() => {
                      if (isMultipleSelect) {
                        this.setState({ selectedIndexs: [...this.state.selectedIndexs, index] });
                      } else {
                        this.setState({ selectedIndex: index });
                      }
                    }}
                    className="image-uploader__item">
                    <div
                      className="image-uploader__image"
                      key={index}>
                      <div className={className}>
                        <Icon name="check"/>
                      </div>
                      <img src={IMAGES_REPO + imageInfo.image} alt={imageInfo.title}/>
                    </div>
                    <div className="image-uploader__img-name">{imageInfo.title}</div>
                  </div>
                );
              })
            }
            {
              values.length === 0 && <div className="no-images">No images</div>
            }
          </Dropzone>
        </div>
        <div className="image-uploader__actions">
          <button
            className="btn btn-sm btn-primary btn-remove pull-right"
            type="button"
            disabled={(isMultipleSelect ? this.state.selectedIndexs.length === 0 : this.state.selectedIndex === -1) || this.state.isUploading || isFetching}
            onClick={() => {
              if (isMultipleSelect) {
                const images = this.state.selectedIndexs.map((valueIndex) => {
                  return values[valueIndex].image;
                });
                select(images);
              } else {
                select(values[this.state.selectedIndex].image);
              }
              cancel();
            }}>Select
          </button>

          <button
            disabled={this.state.isUploading || isFetching}
            onClick={cancel}
            type="button"
            className="btn btn-sm btn-primary btn-remove pull-right">Cancel
          </button>

          <button
            disabled={this.state.isUploading || isFetching}
            className="btn btn-sm btn-primary btn-remove"
            onClick={() => this.refs.dropzoneRef.open()}>
            Upload
          </button>

        </div>
      </div>
    );
  }
}

ImageUploader.propTypes = {};
ImageUploader.defaultProps = {};

export default connect(
  (state) => {
    return {
      images: state.images
    };
  },
  (dispatch) => {
    return bindActionCreators({ getAsync: get }, dispatch);
  }
)(ImageUploader);




// WEBPACK FOOTER //
// ./src/components/ImageUploader/index.js